import Plausible from 'plausible-tracker'
import { TRACKING_ENABLED } from '../config';

const { trackPageview, trackEvent } = Plausible({
  trackLocalhost: TRACKING_ENABLED || false,
  domain: process.env.PLAUSIBLE_DOMAIN || 'gps.globe-groupe.com',
})

// No specific project: likely a Globe technician or head-office admin
const analyticsClient = (project) => (project === 'Not specified' ? 'GLOBE SIÈGE' : project)

export { trackPageview, trackEvent, analyticsClient }
